// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"fPnfC":[function(require,module,exports,__globalThis) {
/**
 * Contact Arrow Animation
 * Handles the hover animation for arrows/icons in buttons and links
 * Creates a swapping animation where the icon moves up and is replaced by
 * another icon coming from below, giving a continuous scrolling effect
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _gsap = require("gsap");
class ContactArrowAnimation {
    constructor(){
        this.animations = [];
        this.init();
    }
    init() {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ()=>this.setup());
        else this.setup();
    }
    setup() {
        // Find all buttons and links that should have the animation
        const selectors = [
            '.enterprise-buttons button',
            '.enterprise-buttons a',
            '.contact-email-link',
            '.contact-return-btn'
        ];
        selectors.forEach((selector)=>{
            const elements = document.querySelectorAll(selector);
            elements.forEach((element)=>{
                // Skip the Send button in contact form
                if (element.classList.contains('contact-form-submit')) return;
                const icon = element.querySelector('img');
                if (icon) this.setupIconAnimation(element, icon);
            });
        });
    }
    setupIconAnimation(parentElement, icon) {
        // Wait for image to load before setting up animation
        if (icon.complete) this.createAnimation(parentElement, icon);
        else icon.addEventListener('load', ()=>this.createAnimation(parentElement, icon));
    }
    createAnimation(parentElement, icon) {
        // Get icon dimensions after image is loaded
        const iconWidth = icon.offsetWidth;
        const iconHeight = icon.offsetHeight;
        // Determine animation direction based on element type
        const isReturnButton = parentElement.classList.contains('contact-return-btn');
        const moveDirection = isReturnButton ? 1 : -1; // 1 for down, -1 for up
        // Create a wrapper with overflow hidden
        const iconWrapper = document.createElement('span');
        iconWrapper.className = 'arrow-animation-wrapper';
        iconWrapper.style.cssText = `
      display: inline-block;
      overflow: hidden;
      vertical-align: middle;
      width: ${iconWidth}px;
      height: ${iconHeight}px;
      position: relative;
    `;
        // Insert wrapper before icon and move icon into it
        icon.parentNode.insertBefore(iconWrapper, icon);
        // Make icon absolute positioned within wrapper
        icon.style.position = 'absolute';
        icon.style.top = '0';
        icon.style.left = '0';
        icon.style.margin = '0';
        iconWrapper.appendChild(icon);
        // Create a clone of the icon positioned below/above inside the same wrapper
        const cloneIcon = icon.cloneNode(true);
        cloneIcon.style.position = 'absolute';
        cloneIcon.style.top = '0';
        cloneIcon.style.left = '0';
        cloneIcon.style.margin = '0';
        iconWrapper.appendChild(cloneIcon);
        // Set initial positions based on direction
        (0, _gsap.gsap).set(icon, {
            y: 0
        });
        (0, _gsap.gsap).set(cloneIcon, {
            y: iconHeight * moveDirection
        });
        // Create the "over" timeline (icon moves in direction, clone comes from opposite)
        const overTimeline = (0, _gsap.gsap).timeline({
            paused: true
        });
        overTimeline.to(icon, 0.3, {
            y: -iconHeight * moveDirection
        }, 0).to(cloneIcon, 0.3, {
            y: 0
        }, 0);
        // Create the "out" timeline (clone moves away, original comes back)
        const outTimeline = (0, _gsap.gsap).timeline({
            paused: true
        });
        outTimeline.to(cloneIcon, 0.3, {
            y: iconHeight * moveDirection
        }, 0).to(icon, 0.3, {
            y: 0
        }, 0);
        // Mouse event handlers
        const handleMouseOver = ()=>{
            if (outTimeline.isActive()) {
                outTimeline.timeScale(3);
                overTimeline.delay(0.1);
            } else overTimeline.delay(0).timeScale(1);
            overTimeline.play(0);
        };
        const handleMouseOut = ()=>{
            if (overTimeline.isActive()) {
                overTimeline.timeScale(3);
                outTimeline.delay(0.1);
            } else outTimeline.delay(0).timeScale(1);
            outTimeline.play(0);
        };
        // Set up hover event listeners
        parentElement.addEventListener('mouseenter', handleMouseOver);
        parentElement.addEventListener('mouseleave', handleMouseOut);
        // Store animation data for cleanup
        this.animations.push({
            parentElement,
            overTimeline,
            outTimeline,
            handleMouseOver,
            handleMouseOut,
            iconWrapper
        });
    }
    destroy() {
        this.animations.forEach(({ parentElement, overTimeline, outTimeline, handleMouseOver, handleMouseOut, iconWrapper })=>{
            if (overTimeline) overTimeline.kill();
            if (outTimeline) outTimeline.kill();
            if (parentElement) {
                parentElement.removeEventListener('mouseenter', handleMouseOver);
                parentElement.removeEventListener('mouseleave', handleMouseOut);
            }
            if (iconWrapper && iconWrapper.parentNode) {
                const icon = iconWrapper.querySelector('img');
                if (icon) parentElement.appendChild(icon);
                iconWrapper.remove();
            }
        });
        this.animations = [];
    }
}
// Initialize
const contactArrowAnimation = new ContactArrowAnimation();
exports.default = contactArrowAnimation;

},{"gsap":"kKW9v","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}]},["fPnfC"], "fPnfC", "parcelRequire8c58", {})

//# sourceMappingURL=jribh.github.io.59cd082b.js.map
